module.exports = __webpack_public_path__ + "static/img/scfy.094f966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/scfy.png
// module id = E4Yy
// module chunks = 12